import { SyntheticEvent, useCallback } from "react";
import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { AIIcon } from "@/assets/icons/app-related/AIIcon";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { oneTimeReportDetailsIncludeAiSelector } from "@/store/reports/selector/one-time/oneTimeReportDetailsIncludeAiSelector";
import { setOneTimeReportDetails } from "@/store/reports/reportsSlice";

export const SendReportIncludeAiToggle = () => {
  const dispatch = useAppDispatch();
  const checked = useAppSelector(oneTimeReportDetailsIncludeAiSelector);

  const handleChange = useCallback(
    (_: SyntheticEvent, checked: boolean) => {
      dispatch(
        setOneTimeReportDetails({
          includeExplainAi: checked,
        }),
      );
    },
    [dispatch],
  );

  return (
    <FormControlLabel
      sx={formControlStyles}
      onChange={handleChange}
      control={<Checkbox size="small" checked={checked} />}
      label={
        <Stack spacing={0.5} direction="row" alignItems="center">
          <AIIcon color="#0000008A" fontSize="small" />
          <Typography variant="body2">Include AI Explanation</Typography>
        </Stack>
      }
    />
  );
};

const formControlStyles = {
  border: 1,
  borderColor: "grey.300",
  borderRadius: 1,
  pl: 0.5,
  pr: 1.5,
  width: "fit-content",
};
